import { useState } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

interface DeletionReasonDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (reason: string) => void;
}

export const DeletionReasonDialog = ({ 
  open, 
  onOpenChange, 
  onConfirm 
}: DeletionReasonDialogProps) => {
  const [selectedReason, setSelectedReason] = useState<string>('customer_canceled');

  const handleConfirm = () => {
    onConfirm(selectedReason);
    onOpenChange(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Ticket</AlertDialogTitle>
          <AlertDialogDescription>
            Please select a reason for deleting this ticket.
          </AlertDialogDescription>
        </AlertDialogHeader>
        
        <RadioGroup value={selectedReason} onValueChange={setSelectedReason}>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="customer_canceled" id="customer_canceled" />
            <Label htmlFor="customer_canceled" className="cursor-pointer">
              Customer canceled
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="no_show" id="no_show" />
            <Label htmlFor="no_show" className="cursor-pointer">
              No show
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="ticket_mistake" id="ticket_mistake" />
            <Label htmlFor="ticket_mistake" className="cursor-pointer">
              Ticket made by mistake
            </Label>
          </div>
        </RadioGroup>

        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm}>
            Delete Ticket
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
